import React, { Component } from "react";
import PropTypes from "prop-types";
import { OrganizationService } from "@services";
import utils from "@utils";
import { Modal } from "../../../../components";

import "./OrganizationEmailModal.scss";

class OrganizationEmailModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false,
			loading: false,
			OrganizationEmail: "",
			OrganizationEmailError: false,
		};

		this.initialState = { ...this.state };
	}

	openModal = () => {
		this.setState({ show: true });
	};

	/** Validates and submits the organization email */
	onSubmit = () => {
		const { lang } = global;
		const { user, callback } = this.props;
		const { OrganizationEmail } = this.state;

		let error = false;

		if (OrganizationEmail === "" || !/\S+@\S+\.\S+/.test(OrganizationEmail)) {
			error = true;
		}

		this.setState({ OrganizationEmailError: error, loading: !error });

		if (error) return;

		OrganizationService.saveAgency({
			id: user.Organization.Id,
			data: {
				...user.Organization,
				OrganizationEmail,
			},
		})
			.then(() => {
				this.resetState();

				utils.notify({
					type: "success",
					message: lang.t("Agency Settings updated successfully"),
				});

				if (callback) callback();
			})
			.catch(({ response }) => {
				this.setState({ loading: false });

				utils.notify({
					type: "error",
					message: response.data.Message || lang.t("Error updating agency settings"),
				});
			});
	};

	resetState = () => {
		this.setState(this.initialState);
	};

	onFormChange = event => {
		const value = event?.target?.value ?? "";
		this.setState({ OrganizationEmail: value });
	};

	onInputKeyPress = event => {
		if (event.key === "Enter") this.onSubmit();
	};

	render() {
		const { lang } = global;
		const { show, OrganizationEmail, OrganizationEmailError, loading } = this.state;

		return (
			<Modal
				id="organization-email-modal"
				size="sm"
				show={show}
				onHide={this.resetState}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Email required")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={this.onSubmit}>
						<div>{lang.t("No email address associated with this agency")}</div>
						<br />
						<div>{`${lang.t("Please provide your agency’s billing email address")}:`}</div>
						<br />
						<div
							className={`row form-group ${OrganizationEmailError ? "has-error" : ""}`}
						>
							<div className="col-xs-12">
								<input
									type="email"
									id="organization-email"
									name="organization-email"
									required
									className="form-control"
									value={OrganizationEmail}
									onChange={this.onFormChange}
									onKeyPress={this.onInputKeyPress}
								/>
							</div>
						</div>
						<br />
						<div className="row">
							<div className="col-xs-6">
								<button
									type="button"
									id="bank-account-verification-cancel"
									className="btn btn-link btn-block"
									onClick={this.resetState}
									disabled={loading}
								>
									{lang.t("Cancel")}
								</button>
							</div>
							<div className="col-xs-6">
								<button
									type="submit"
									id="verify-bank-account"
									className="btn btn-primary btn-block"
									disabled={loading}
								>
									{loading ? lang.t("Loading") : lang.t("Continue")}
								</button>
							</div>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		);
	}
}

OrganizationEmailModal.propTypes = {
	user: PropTypes.object,
	callback: PropTypes.func,
};

OrganizationEmailModal.defaultProps = {
	user: {},
	callback: undefined,
};

export default OrganizationEmailModal;
